import { ROUTE_PATHS } from '@config/routes';

/**
 * Resolves where to send the merchant after a 403:
 * always Setup Guide (home for new and existing merchants).
 */
export const resolveMerchantForbiddenRedirectPath = (_state) => ROUTE_PATHS.SETUP_GUIDE;

export default resolveMerchantForbiddenRedirectPath;
